/* eslint-disable no-undef */
import axios from '_lib/encrypt/axios';
import { handleRylaiserviceTag } from '@heybox/hb-request';
import { getOSType, webpFormat, getRequestUrl, getUrlParam, getHeyboxEnv } from '_lib/utils';

console.log('[getHeyboxEnv]', getHeyboxEnv(true));

handleRylaiserviceTag(axios, getHeyboxEnv(true).local_rylaiservice_tag_config ?? {});

const __DEFAULT_PARAMS__ = {
  os_type: 'web',
  app: 'heybox',
  client_type: 'mobile',
  version: '999.0.4',
  x_client_type: 'web',
  x_os_type: getOSType(),
  x_client_version: getUrlParam('version'),
  x_app: getUrlParam('x_app') || 'heybox',
  heybox_id: getUrlParam('heybox_id') || '-1',
};

window.SUPPORT_WEBP = undefined;
export function axiosGetHandler(url, args = {}, apps = {}) {
  let params = Object.assign({}, __DEFAULT_PARAMS__, apps, args);

  if (window.SUPPORT_WEBP == undefined) {
    return Promise.all([httpRequest('GET', url, params), webpFormat()]).then((res_list) => res_list[0]);
  } else {
    return httpRequest('GET', url, params);
  }
}

export function axiosPostHandler(url, args = {}, formdata, apps = {}) {
  let params = Object.assign({}, __DEFAULT_PARAMS__, apps, args);

  if (window.SUPPORT_WEBP == undefined) {
    return Promise.all([httpRequest('POST', url, params, formdata), webpFormat()]).then((res_list) => res_list[0]);
  } else {
    return httpRequest('POST', url, params, formdata);
  }
}

/**
 * 测试时返回mock数据
 */
function handleMockData(args) {
  let data,
    time = 0;
  if (args.mock instanceof Array) {
    [data, time = 0] = args.mock;
  } else {
    data = args.mock;
  }
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({ data });
    }, time);
  });
}

function httpRequest(method, url, args, formdata) {
  /**
   * 测试时返回mock数据
   */
  if (args.mock) {
    if (IS_PRO) {
      delete args.mock;
    } else {
      return handleMockData(args);
    }
  }

  if (method === 'POST') {
    return axios.post(getRequestUrl(url), formdata, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
      timeout: 10000,
      responseType: 'json',
      params: args,
    });
  } else {
    return axios.get(getRequestUrl(url), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
      },
      timeout: 10000,
      responseType: 'json',
      params: args,
    });
  }
}
